// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.appShell_navBar__1cW4o {
    width: 175px;
    background-color: var(--elv-gray-5);
    border-width: 0;
}

.appShell_main__dhfKj {
    width: calc(100vw - 50px);
}

.appShell_navTitle__S23X\\+ {
    font-size: 14;
    color: var(--mantine-color-black);
    background-color: var(--elv-gray-5);
    width: 140px;
}

.appShell_inactiveNavTitle__tzvPI {
    font-weight: 400;
}

.appShell_activeNavTitle__tFtc8 {
    font-weight: 700;
}`, "",{"version":3,"sources":["webpack://./src/assets/styles/appShell.module.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mCAAmC;IACnC,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,iCAAiC;IACjC,mCAAmC;IACnC,YAAY;AAChB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB","sourcesContent":[".navBar {\n    width: 175px;\n    background-color: var(--elv-gray-5);\n    border-width: 0;\n}\n\n.main {\n    width: calc(100vw - 50px);\n}\n\n.navTitle {\n    font-size: 14;\n    color: var(--mantine-color-black);\n    background-color: var(--elv-gray-5);\n    width: 140px;\n}\n\n.inactiveNavTitle {\n    font-weight: 400;\n}\n\n.activeNavTitle {\n    font-weight: 700;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"navBar": `appShell_navBar__1cW4o`,
	"main": `appShell_main__dhfKj`,
	"navTitle": `appShell_navTitle__S23X+`,
	"inactiveNavTitle": `appShell_inactiveNavTitle__tzvPI`,
	"activeNavTitle": `appShell_activeNavTitle__tFtc8`
};
export default ___CSS_LOADER_EXPORT___;
